import { Grid } from "@mui/material";
import { useSelector, useDispatch } from 'react-redux';
import ButtonSwitch from '../form/ButtonSwitch';
import { edit } from '../../slices/categoriesBulkEditSlice';
import { edit as settingsCategoriesSelectedSlice } from '../../slices/settingsCategoriesSelectedSlice';
import { useState } from "react";
import TubeSubmit from "../form/TubeSubmit";
import { post, appUrl } from '../../utils/fetch';
import PropTypes from 'prop-types';
import DialogComponent from "../dialog/Dialog";

function CategoriesBulkEdit(props) {
    const { handleClose, getData } = props;
    const selected = useSelector((state) => state.settingsCategoriesSelected);
    const categoriesBulkEdit = useSelector((state) => state.categoriesBulkEdit);
    const [ isLoadingUpdate, setIsLoadingUpdate ] = useState(false);
    const [ isOpenDialog, setIsOpenDialog ] = useState(false);
    const [ isOpenNoFiles, setIsOpenNoFiles ] = useState(false);

    const dispatch = useDispatch();

    return (
        <>
            <Grid container spacing={3}>
                <Grid item md={4}>
                    <div className='title-14'>Selected categories</div>
                    {selected.selectedNames.map((item, i) => (
                        <div class="bulk-edit-item">
                            {item}
                        </div>
                    ))}
                </Grid>
                <Grid item md={8}>
                    <div className='title-14'>Status</div>
                    <ButtonSwitch
                        stateName={"categoriesBulkEdit"}
                        valueName={"status"}
                        dispatchFunc={edit}
                        data={[
                            { id: 0, label: "Do not change" },
                            { id: 1, label: "Online", color: "green" },
                            { id: 2, label: "Offline", color: "red" }
                        ]}
                    />
                </Grid>
                <Grid item md={12}>
                    <TubeSubmit
                        label="Update"
                        onClick={selected.selectedNames.length ? () => post(`${appUrl}/api/categories-bulk-edit`, {
                            ...categoriesBulkEdit,
                            selected: selected.selected
                        }, () => {
                            setIsLoadingUpdate(false);
                            getData();
                            handleClose();
                            setIsOpenDialog(true);
                            dispatch(edit("default"));
                            dispatch(settingsCategoriesSelectedSlice("default"));
                        }, () => setIsLoadingUpdate(true)) : () => setIsOpenNoFiles(true)}
                        isLoading={isLoadingUpdate}
                    />
                    <TubeSubmit
                        variant="outlined"
                        sx={{
                            marginLeft: "10px"
                        }}
                        label="Cancel"
                        onClick={() => handleClose()}
                    />
                </Grid>
            </Grid>
            <DialogComponent
                content={"Changes have been made"}
                open={isOpenDialog}
                onClose={() => setIsOpenDialog(false)}
                buttons={[
                    {
                        variant: "contained",
                        label: "OK",
                        color: "primary",
                        onClick: () => setIsOpenDialog(false),
                    }
                ]}
            />
            <DialogComponent
                content={"You have not selected any categories."}
                open={isOpenNoFiles}
                onClose={() => setIsOpenNoFiles(false)}
                buttons={[
                    {
                        variant: "contained",
                        label: "OK",
                        color: "primary",
                        onClick: () => setIsOpenNoFiles(false),
                    }
                ]}
            />
        </>
    );
}

export default CategoriesBulkEdit;

CategoriesBulkEdit.propTypes = {
    handleClose: PropTypes.func.isRequired,
    getData: PropTypes.func
};